const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the accept invite Directive which defines the sign in form behavior and markup
 * @argument {authorization} AuthorizationResource injected to access the authorization resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('acceptInvite', ['Invitations', 'Application', 'Authorization', 'Analyze', 'AuthorizationResource', '$translate', function (Invitations, Application, Authorization, Analyze, AuthorizationResource, $translate) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/accept-invite.html'),
    controller: function () {
      var self = this;
      var params = Application.navigation.getUrlParameters();
      var url = Application.navigation.getUrl();
      self.passwordConfirm = '';

      self.displaySuccess = false;
      self.credentials = {
        first_name: '',
        last_name: '',
        invitation_key: params.invite_code,
        password: ''
      };

      self.loading = false;

      self.accept = function () {
        if (!self.credentials.first_name || !self.credentials.last_name ||!self.credentials.password || !self.credentials.invitation_key) {
          console.log('missing information');
          return;
        }
        var domain = Application.companyDomain;
        self.loading = true;
        Invitations.accept({
          domain: domain,
          authtoken: 'public'
        }, self.credentials, function (data) {
          var login = {domain: Application.navigation.getHost(), email: data.email, password: self.credentials.password};
          AuthorizationResource.signin({}, login, async function (data) {
            if (Authorization.validateAndUseAuthToken(data)) {
              self.loading = false;
              Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
              Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
              Application.analyticsProvider.trackEvent('signin');
              Application.navigation.goToHome();
            }
          }, function (error) {
            self.loading = false;
            Authorization.clearAuthToken();
            console.log('Error', error);
            Application.notifications.setError(self.translations['modules.notifications.invalidCode']);
          });
        }, function (error) {
          self.loading = false;
          Authorization.clearAuthToken();
          console.log('Error', error);
          Application.notifications.setError(self.translations['modules.notifications.invalidCode']);
        });
      };
      self.initialize = function() {
          self.invite_code = params.invite_code.slice(0);
          if (!self.invite_code) {
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCode']});
          }
          if( self.passwordConfirm !== self.credentials.password) {

            Application.messaging.addMessage({type: 'error', text: self.translations['preauth.acceptinvite.passwords_dont_match'], duration: 5});
            return;
          }
          var domain = Application.companyDomain;
          self.loading = true;
          Invitations.openFind({
            token: self.invite_code,
            domain: domain,
            authtoken: 'public',
            fields: 'email,first_name,last_name,token'
          }, function(data) {
            if (!data.length || !data[0].first_name) {
              self.loading = false;
              self.tokenUsed = true;
              Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCode']});
              return;
            }
            self.accept();

          }, function(err) {
            console.log('error finding the token.');
          });


      };

      $translate([
        'modules.notifications.invalidCredentials',
        'modules.notifications.invalidCode',
        'preauth.acceptinvite.passwords_dont_match'
      ]).then(function(data){
        self.translations = data;
      });

    },
    controllerAs: 'invite'
  };
}]);
